<template>
    <div class="reset-password" :class="{ 'mx-5': !isMobile }">
        <div class="reset-pass-wrapper">
            <div class="head-text">
                <span class="reset-pass-head">Change your password</span>
            </div>
            <div class="inputs-wrapper">
                <div class="solo-input position-relative">
                    <label for="password" class="input-label">Current password * </label>
                    <input
                        id="password"
                        class="settings-form settings-form-user"
                        :type="isFlagCurrent ? 'text' : 'password'"
                        v-model="password"
                        autocomplete="new-password"
                    />
                    <i
                        :class="{
                            'fa fa-eye-slash show-password': !isFlagCurrent,
                            'fa fa-eye show-password': isFlagCurrent
                        }"
                        @click="isFlagCurrent = !isFlagCurrent"
                        style="position: absolute; color: #8b8b8b; top: 55%; right: 3%"
                    ></i>
                </div>
                <p class="error-form-message" v-if="passwordError">{{ passwordError }}</p>
                <div class="solo-input position-relative">
                    <label for="new-password" class="input-label">New password * </label>
                    <input
                        id="new-password"
                        class="settings-form settings-form-user"
                        :type="isFlag ? 'text' : 'password'"
                        v-model="newPassword"
                    />
                    <i
                        :class="{
                            'fa fa-eye-slash show-password': !isFlag,
                            'fa fa-eye show-password': isFlag
                        }"
                        @click="isFlag = !isFlag"
                        style="position: absolute; color: #8b8b8b; top: 55%; right: 3%"
                    ></i>
                </div>
                <p class="error-form-message" v-if="newPasswordError">
                    {{ newPasswordError }}
                </p>
                <div class="solo-input position-relative">
                    <label for="confirm-password" class="input-label">
                        Confirm you password *
                    </label>
                    <input
                        id="confirm-password"
                        class="settings-form settings-form-user"
                        :type="isFlagConfirm ? 'text' : 'password'"
                        v-model="repeatNewPassword"
                    />
                    <i
                        :class="{
                            'fa fa-eye-slash show-password': !isFlagConfirm,
                            'fa fa-eye show-password': isFlagConfirm
                        }"
                        @click="isFlagConfirm = !isFlagConfirm"
                        style="position: absolute; color: #8b8b8b; top: 55%; right: 3%"
                    ></i>
                </div>
                <p class="error-form-message" v-if="repeatNewPasswordError">
                    {{ repeatNewPasswordError }}
                </p>
            </div>
        </div>
        <div class="d-flex">
            <div class="d-flex flex-column btn-wrap">
                <a class="pass-reset-link" href="/password/reset"> Reset your password? </a>
                <button class="call-to-action-btn" @click="changePassword()">
                    <span class="btn-action-text">Save</span>
                </button>
                <button class="btn-call-remove" @click="closeModal">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { profileMixin } from '../../../mixins/user-settings/userSettingsMixin'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    export default {
        name: 'PasswordResetModal',
        mixins: [profileMixin],
        props: {
            resetPass: Boolean
        },
        setup() {
            const { isMobile } = useCheckScreen()

            return { isMobile }
        },
        methods: {
            closeModal() {
                this.$emit('close')
            }
        },
        async mounted() {
            await this.getUserData()

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @media screen and (max-width: 600px) {
        .reset-pass-head {
            font-size: 32px !important;
            line-height: 110% !important;
            letter-spacing: -0.64px !important;
        }
        .reset-password {
            padding: 0px !important;
            background: inherit !important;
        }
        .btn-wrap {
            margin-top: 40px !important;
        }
        .head-text {
            margin-top: 0px !important;
        }
    }
    .pass-reset-link {
        color: #cdeb09;
        font-family: 'Instrument Sans';
        font-size: 15px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        cursor: pointer;
    }
    .reset-password {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        border-radius: 15px;
        background: #262626;
        padding-left: 90px;
        padding-right: 130px;
        padding-bottom: 105px;
        z-index: 6;
        max-width: 1440px;
    }

    .reset-pass-head {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .head-text {
        margin-top: 90px;
        margin-bottom: 50px;
    }
    .reset-pass-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        flex: 1 0 0;
    }
    .solo-input {
        display: flex;
        gap: 6px;
        flex-direction: column;
        align-self: stretch;
    }
    .settings-form {
        display: flex;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        color: #dedede;
    }
    .inputs-wrapper {
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        width: 100%;
    }
    .input-label {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .btn-wrap {
        flex: 1;
        align-items: center;
        gap: 8px;
        margin-top: 95px;
    }
    .call-to-action-btn {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex: 1;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
        max-width: 460px;
        width: 100%;
    }
    .btn-action-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .btn-call-remove {
        color: #8b8b8b;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration-line: underline;
        background: none;
        border: none;
    }
    .error-form-message {
        color: #ed3c0d;
        margin-bottom: 0;
    }
</style>
